import { render, staticRenderFns } from "./MunichLifecycle.vue?vue&type=template&id=60023679"
import script from "./MunichLifecycle.vue?vue&type=script&lang=js"
export * from "./MunichLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports